import type { AxiosRequestConfig, Canceler } from 'axios'
import axios from 'axios'
import qs from 'qs'
import { isFunction } from '@/utils/is'

// Used to store the identification and cancellation function of each request
let pendingMap = new Map<string, Canceler>()

export const getPendingUrl = (config: AxiosRequestConfig, requestOptions?) => {
  return requestOptions && requestOptions.simpleCancel ? [config.method, config.url].join('&') : [config.method, config.url, qs.stringify(config.data), qs.stringify(config.params)].join('&')
}

export class AxiosCanceler {
  /**
   * Add request
   * @param {Object} config
   */
  addPending(config: AxiosRequestConfig, requestOptions?) {
    this.removePending(config, requestOptions)
    const url = getPendingUrl(config, requestOptions)
    config.cancelToken
      = config.cancelToken
      || new axios.CancelToken((cancel) => {
        if (!pendingMap.has(url)) {
          // If there is no current request in pending, add it
          pendingMap.set(url, cancel)
        }
      })
  }

  /**
   * @description: Clear all pending
   */
  removeAllPending() {
    pendingMap.forEach((cancel) => {
      cancel && isFunction(cancel) && cancel()
    })
    pendingMap.clear()
  }

  /**
   * Removal request
   * @param {Object} config
   */
  removePending(config: AxiosRequestConfig, requestOptions?) {
    const url = getPendingUrl(config, requestOptions)

    if (pendingMap.has(url)) {
      // If there is a current request identifier in pending,
      // the current request needs to be cancelled and removed
      const cancel = pendingMap.get(url)
      cancel && cancel(url)
      pendingMap.delete(url)
    }
  }

  /**
   * @description: reset
   */
  reset(): void {
    pendingMap = new Map<string, Canceler>()
  }
}
